const API_BASE =
  process.env.REACT_APP_FASTAPI_SEVER_URL ||
  process.env.NEXT_PUBLIC_API_BASE ||
  "";

const TOKEN_KEY = "concierge_cms_access_token";

export function setConciergeToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {}
}

export function getConciergeToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function clearConciergeToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export async function conciergeCmsLogin(phone, pin) {
  const res = await fetch(`${API_BASE}/concierge/user/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone, pin }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.detail || "로그인에 실패했습니다.");
  }
  return data;
}

export async function conciergeCmsFindPin(name, phone) {
  const res = await fetch(`${API_BASE}/concierge/user/find-pin`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, phone }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.detail || "핀번호 찾기에 실패했습니다.");
  }
  return data;
}

export async function conciergeCmsMe() {
  const token = getConciergeToken();
  if (!token) throw new Error("NO_TOKEN");
  const res = await fetch(`${API_BASE}/concierge/user/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("UNAUTHORIZED");
  return res.json();
}

export async function conciergeAuthFetch(url, opts = {}) {
  const token = getConciergeToken();
  const headers = {
    ...(opts.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  const res = await fetch(`${API_BASE}${url}`, { ...opts, headers });
  if (res.status === 401 || res.status === 403) {
    clearConciergeToken();
    if (window.location.pathname.startsWith("/concierge/manage")) {
      window.location.href = "/concierge/manage/login";
    }
  }
  return res;
}
